var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsDateString, IsOptional, IsString } from 'class-validator';
import { ApiPropertyMetadata } from '../../../decorators';
import { RESERVATION_STATE_QUERY_API_PROPERTY, } from '../../../types';
export class GetMonthlyStatisticOperationRateQueryDto {
}
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], GetMonthlyStatisticOperationRateQueryDto.prototype, "startDate", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], GetMonthlyStatisticOperationRateQueryDto.prototype, "endDate", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], GetMonthlyStatisticOperationRateQueryDto.prototype, "vehicleModelIds", void 0);
__decorate([
    IsString(),
    IsOptional(),
    ApiPropertyMetadata({ type: 'string', enum: ['MAX', 'AVERAGE'] }),
    __metadata("design:type", String)
], GetMonthlyStatisticOperationRateQueryDto.prototype, "valueType", void 0);
__decorate([
    IsOptional(),
    ApiPropertyMetadata(RESERVATION_STATE_QUERY_API_PROPERTY),
    __metadata("design:type", Object)
], GetMonthlyStatisticOperationRateQueryDto.prototype, "state", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetMonthlyStatisticOperationRateQueryDto.prototype, "branchIds", void 0);
